<!--
  - ALBUM画面
  -
  - see: 画面定義書_G-NHA-002_ALBUM画面_v1.1.xlsx
  -->
<template>
<div>
<div class="navbar navbar-fixed-top">
  <div class="navbar-inner">
    <div class="container-fluid">
      <a class="btn btn-navbar" data-toggle="collapse" data-target=".nav-collapse">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
      <a class="brand" href="/#/AlbumCatalog">Panolib</a>
      <div class="nav-collapse">
        <ul class="nav">
          <li class="active"><a href="/#/AlbumCatalog">カテゴリ一覧</a></li>
          <li><a href="/#/UserKanri">ユーザー管理</a></li>
          <li v-if="this.$store.state.myapp.kengen === '1' || this.$store.state.myapp.kengen === '2'"><a href="/#/Riyo">利用状況一覧</a></li>
          <li v-if="this.$store.state.myapp.kengen === '1'"><a href="/#/Contract">契約情報管理</a></li>
        </ul>
        <p class="navbar-text pull-right"><a href="/#/Top">ログアウト</a></p>
      </div><!--/.nav-collapse -->
    </div>
  </div>
</div>
<div class="nav" style="height: 9%">
    <ul style="margin: 0">
        <li style="display: inline">
            <span>現在位置：</span>
        </li>
        <li style="display: inline">
            <a href="/#/AlbumCatalog">H O M E</a>
        </li>
         >
        <li style="display: inline">
            <a href="/#/AlbumCatalog">カテゴリ一覧</a>
        </li>
         >
        <li style="display: inline">
            <a  class="nowPage" style="text-decoration: none; color: black">アルバム一覧</a>
        </li>
    </ul>
</div>
<div class="page-header">
  <h1 style="float: left;">アルバム一覧</h1>
  <div style="float: left; font-size: 18px; padding-top: 5px; margin-left: 10px;">{{showCatalogName()}}</div>
  <div style="height:40px;"></div>
  <br />
  <ul class="pager" style="margin-bottom: 13px; float: left;">
        <li class="previous">
          <a href="/#/AlbumCatalog" style="margin-right: 10px;">&larr; カテゴリに戻る</a>
        </li>
  </ul>
  <a class="btn btn-primary" href="/#/AlbumCreate">アルバム作成</a>
</div>
<table class="table table-striped table-bordered">
  <thead>
    <tr >
      <th width="105">アルバム名 <a id="albumOrdBukenme" class="btn" @click="order('bukenme')" style="font-size:6px; width:20px; height:15px; float:right; padding:0px;">▼</a></th>
      <th width="70">作成者<a id="albumOrdUserid" class="btn" @click="order('userid')" style="font-size:6px; width:20px; height:15px; float:right; padding:0px;">▼</a></th>
      <th width="100">作成日時<a id="albumOrdSakusehi" class="btn" @click="order('sakusehi')" style="font-size:6px; width:20px; height:15px; float:right; padding:0px;">▼</a></th>
      <th width="100">更新日時<a id="albumOrdKoushinhi" class="btn" @click="order('koushinhi')" style="font-size:6px; width:20px; height:15px; float:right; padding:0px;">▼</a></th>
      <th width="40">画像数</th>
      <th style="min-width:150px;">アルバムリンク</th>
      <th style="min-width:150px;">埋め込みコード</th>
      <th width="140">利用可能ドメイン<a id="albumOrdDomain" class="btn" @click="order('domain')" style="font-size:6px; width:20px; height:15px; float:right; padding:0px;">▼</a></th>
      <th width="200" style="text-align: center;">操作</th>
    </tr>
  </thead>
  <tbody>
      <tr v-for="i in this.$store.state.myapp.albums" :key="i" @click="getDataId(i.id, i.bukenme, i.picnum, i.userid)">
      <td>{{i.bukenme}}</td>
      <td>{{i.userid}}</td>
      <td>{{i.sakusehi}}</td>
      <td>{{i.koushinhi}}</td>
      <td>{{i.picnum}}</td>
      <td>{{i.panoPreviewUrl}}</td>
      <td>{{i.iframeCode}}</td>
      <td>{{i.domain}}</td>
      <td style="min-width:165px;">
        <div class="btn-group" style="width:165px; margin: 0 auto;">
          <a class="btn" @click="edit(i)">編&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;集</a>
          <a class="btn" @click="remove(i)">削&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除</a>
        </div>
        <div class="btn-group" style="width:165px; margin: 0 auto; margin-top: 5px;">
          <a class="btn" @click="panoPreview(i)" :disabled="!i.panoPreviewUrl">プレビュー</a>
          <a class="btn" @click="setDomain(i)">ドメイン</a>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<div class="modal hide fade" id="album-modal">
  <div class="modal-header">
    <a class="close" data-dismiss="modal">×</a>
    <h3>アルバム削除</h3>
  </div>
  <div class="modal-body" align="center">
    <p><strong>アルバムを削除しますか？</strong></p>
    <p>この操作によりアルバム内のすべての画像が削除されます。</p>
  </div>
  <div class="modal-footer">
    <a href="#" class="btn" data-dismiss="modal">キャンセル</a>
    <a id="album-modal-delete-btn" href="#" class="btn btn-danger">&nbsp;&nbsp;&nbsp;&nbsp;削除&nbsp;&nbsp;&nbsp;&nbsp;</a>
  </div>
</div>
</div>
</template>
<script>
import {albumViewModel} from '@/view-model/Album'
import {ACTIONS} from '@/store/action-types'

export default {
  mixins: [albumViewModel],
  methods: {
  // エラーがある場合、ポップアップ画面を表示する。
    toDisclosureStatement () {
      if (this.$root.isMobile.any === true) {
        this.$store.dispatch(ACTIONS.DOCUMENT_OPEN, {name: 'DisclosureStatementSp', showScrollBtn: true})
      } else {
        this.$store.dispatch(ACTIONS.DOCUMENT_OPEN, {name: 'DisclosureStatement', showScrollBtn: true})
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Album.vue